module.exports = __webpack_public_path__ + "img/multi_pic.b4d16978.png";